/**
 * The URL a table QR encodes (F-FE-N100).
 *
 * Short on purpose: the symbol is printed small and read in restaurant
 * lighting, and every character is more modules. The slug is the whole payload
 * — the destination behind it stays editable, so a laminated card survives a
 * domain move or a retarget without being reprinted.
 *
 * Returns '' when either half is missing so a caller renders nothing rather
 * than a confidently broken code.
 */
export function tableQrUrl(publicBase: string, slug: string): string {
  const base = (publicBase ?? '').trim().replace(/\/+$/, '')
  const s = (slug ?? '').trim()
  if (!base || !s) return ''
  return `${base}/q/t/${s}`
}
